import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  private selectedCountrySubject = new BehaviorSubject<string>('AT');
  selectedCountry$ = this.selectedCountrySubject.asObservable();

  constructor() {}

  setSelectedCountry(country: string) {
    this.selectedCountrySubject.next(country);
  }

  getSelectedCountry(): string {
    return this.selectedCountrySubject.value;
  }
} 